import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Btn } from "@/components/ui-kit";
import api from "@/lib/api";
import Modal from "@/pages/ops/Modal";
import { sessionTag, IssueBadges } from "@/components/ShiftCheck";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });

export default function ChangeRequestModal({ shift, onClose, onDone }) {
  const [sug, setSug] = useState([]);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/pro/roster/${shift.id}/suggestions`).then((r) => setSug(r.data.dates || [])).catch(() => setSug([]));
  }, [shift.id]);
  const send = async () => {
    if (!date) return toast.error("Pick a preferred date");
    setBusy(true);
    try { await api.post(`/pro/roster/${shift.id}/change-request`, { date, reason }); toast.success("Request sent to Ops"); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not send request"); }
    finally { setBusy(false); }
  };
  return (
    <Modal title="Request a date change" subtitle={`${shift.patient_name || "General shift"} · ${fmt(shift.date)} ${shift.start}–${shift.end}`} onClose={onClose}>
      {shift.session_info && <p className="text-[12.5px] font-semibold text-slate-800 mb-2" data-testid="cr-session">{sessionTag(shift.session_info)}</p>}
      <IssueBadges issues={shift.issues} testid="cr-issues" />
      <div className="pq-label mt-3 mb-1.5">Suggested free dates</div>
      <div className="flex flex-wrap gap-1.5" data-testid="cr-suggestions">
        {sug.length === 0 && <span className="text-[12px] text-slate-500">No free dates found in the next 30 days — pick one below.</span>}
        {sug.map((d) => (
          <button key={d.date} type="button" onClick={() => setDate(d.date)} data-testid={`cr-date-${d.date}`}
            className={`rounded-full border px-2.5 py-1 text-[11.5px] font-semibold transition-colors ${date === d.date ? "bg-teal-700 border-teal-700 text-white" : "border-teal-200 bg-white text-teal-800 hover:bg-teal-50"}`}>
            {fmt(d.date)} · {d.start}
          </button>
        ))}
      </div>
      <label className="block mt-3"><span className="pq-label">Or another date</span>
        <input type="date" className="pq-input mt-1" value={date} onChange={(e) => setDate(e.target.value)} data-testid="cr-date-input" /></label>
      <label className="block mt-3"><span className="pq-label">Reason (optional)</span>
        <input className="pq-input mt-1" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="cr-reason" /></label>
      <p className="text-[11.5px] text-slate-500 mt-2">Ops reviews the request and makes the change.</p>
      <div className="flex gap-2 mt-4 justify-end">
        <Btn onClick={onClose}>Cancel</Btn>
        <Btn variant="primary" onClick={send} disabled={busy} data-testid="cr-send">{busy ? "Sending…" : "Send to Ops"}</Btn>
      </div>
    </Modal>
  );
}
